import React, { Fragment } from "react";
import { closeLayerFn, Container } from "../../Layout";
import { ContentsService } from "./ServiceTerms";
import { ContentsPrivate } from "./PrivateTerms";
import { ContentsLocation } from "./LocationTerms";
import Recent from "./PrivateTerms/recent";

export default (props) => {
  const closeViewer = (target) => {
    closeLayerFn(target);
  };

  return (
    <Fragment>
      <div
        className="blacklayer-container list-full-layer"
        id="serviceViewer"
        style={{ maxWidth: "100%", zIndex: "60" }}
      >
        <div className="bl-blind" style={{ backgroundColor: "WHITE" }}></div>
        <div className="in-layerarea">
          <div className="in-diet-layerinfo">
            <a
              className="btn-closex-blk"
              onClick={() => closeViewer($("#serviceViewer"))}
              style={{ zIndex: "10" }}
            ></a>

            <divq
              style={{
                backgroundColor: "WHITE",
                width: "100%",
                position: "fixed",
                bottom: "0",
                height: "100%",
              }}
            >
              <div className="login-pw-box re" style={{ height: "100%", padding: "23px" }}>
                <div className="pw-inp-box" style={{ height: "84%", padding: "0" }}>
                  <span>서비스 이용약관(필수)</span>

                  <div
                    className="terms-cont-list"
                    style={{ height: "100%", overflow: "auto", marginTop: "25px", paddingTop: "0" }}
                  >
                    <ContentsService />
                  </div>
                </div>
              </div>
            </divq>
          </div>
        </div>
      </div>

      <div
        className="blacklayer-container list-full-layer"
        id="privateViewer"
        style={{ maxWidth: "100%", zIndex: "60" }}
      >
        <div className="bl-blind" style={{ backgroundColor: "WHITE" }}></div>
        <div className="in-layerarea">
          <div className="in-diet-layerinfo">
            <a
              className="btn-closex-blk"
              onClick={() => closeViewer($("#privateViewer"))}
              style={{ zIndex: "10" }}
            ></a>

            <div
              style={{
                backgroundColor: "WHITE",
                width: "100%",
                position: "fixed",
                bottom: "0",
                height: "100%",
              }}
            >
              <div className="login-pw-box re" style={{ height: "100%", padding: "23px" }}>
                <div className="pw-inp-box" style={{ height: "84%", padding: "0" }}>
                  <span>개인정보 수집, 이용약관(필수)</span>

                  <div
                    className="terms-cont-list"
                    style={{ height: "100%", overflow: "auto", marginTop: "25px", paddingTop: "0" }}
                  >
                    <Recent />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="blacklayer-container list-full-layer"
        id="locationViewer"
        style={{ maxWidth: "100%", zIndex: "60" }}
      >
        <div className="bl-blind" style={{ backgroundColor: "WHITE" }}></div>
        <div className="in-layerarea">
          <div className="in-diet-layerinfo">
            <a
              className="btn-closex-blk"
              onClick={() => closeViewer($("#locationViewer"))}
              style={{ zIndex: "10" }}
            ></a>

            <div
              style={{
                backgroundColor: "WHITE",
                width: "100%",
                position: "fixed",
                bottom: "0",
                height: "100%",
              }}
            >
              <div className="login-pw-box re" style={{ height: "100%", padding: "23px" }}>
                <div className="pw-inp-box" style={{ height: "84%", padding: "0" }}>
                  <span>위치기반 서비스 이용약관(필수)</span>

                  <div
                    className="terms-cont-list"
                    style={{ height: "100%", overflow: "auto", marginTop: "25px", paddingTop: "0" }}
                  >
                    <ContentsLocation />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};